import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserUI } from '@src/models';

import { ApiService } from './api.service';
import { WebSocketService } from './web-socket.service';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class InternalMessengerService {
  isUsed = false;

  private readonly apiService = inject(ApiService);
  private readonly wss = inject(WebSocketService);
  private readonly router = inject(Router);
  readonly store = inject(StoreService);

  readonly publicChatUnreadMessageCount$ = this.wss.publicChatUnreadMessageCount$;
  readonly unreadChatsCount$ = this.wss.unreadChatsCount$;

  get connectionId() {
    return this.wss.connectionId;
  }

  async init(messengerUrl: string, token: string, authUserId: string) {
    try {
      this.isUsed = !!messengerUrl;
      await this.wss.connect(messengerUrl, token, authUserId);
    } catch (error) {
      console.log(error);
    }
  }

  async logOut() {
    this.store.clearStore();
    await this.wss.closeConnection();
  }

  openChatWithUser(user: UserUI) {
    if (!user.id || !user.fullName) {
      return;
    }

    this.apiService
      .createPrivateChat({
        anotherUserId: user.id,
      })
      .subscribe(res => {
        const chatId = res.id;
        this.router.navigate(['/chats-inner', chatId]);
      });
  }

  createPublicChat(chatName: string, chatDescription: string = '') {
    return this.apiService.createPublicChat({ chatName, chatDescription });
  }

  userNameChanged(userId: string) {
    return this.apiService.userNameChanged(userId);
  }

  userAvatarChanged(userId: string) {
    return this.apiService.userAvatarChanged(userId);
  }
}
